<footer class="footer footer-principal" role="contentinfo">
    <div class="footer__region1">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-3 text-center text-md-left">
                    <div class="logos">
                        <div class="logo logo--0">
                            <a href="https://sante.gouv.fr/" title="{{ 'global.ministere' | translate }} {{ 'footer.newWindow' | translate }}" target="_blank" rel="nofollow noopener">
                                <img src="../../../assets/img/logo-ministere.svg" alt="{{ 'global.ministere' | translate }}" width="133" height="77" loading="lazy" />
                            </a>
                        </div>
                        <div class="logo logo--1">
                            <a href="https://esante.gouv.fr/" title="{{ 'global.ans' | translate}} {{ 'footer.newWindow' | translate }}" target="_blank" rel="nofollow noopener">
                                <img src="../../../assets/img/logo-ANS-footer.svg" alt="{{ 'global.ans' | translate}}" width="106" height="74" loading="lazy" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3 text-center text-md-left">
                    <p class="footer__title">
                        {{ 'footer.adresse1' | translate }}
                        <br />
                        {{ 'footer.adresse2' | translate }} <br />
                        {{ 'footer.adresse3' | translate }}
                    </p>

                    <div class="m-social">
                        <ul class="m-social__list">
                            <li class="m-social__item">
                                <a class="m-social__link" href="https://www.linkedin.com/company/agence-du-numerique-en-sante/" target="_blank" rel="nofollow noopener">
                                    <div class="m-social__icon">
                                        <svg class="svg-icon svg-linkedin" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#linkedin"></use></svg>
                                    </div>
                                    <span class="sr-only">linkedin</span>
                                </a>
                            </li>
                            <li class="m-social__item">
                                <a class="m-social__link" href="https://x.com/esante_gouv_fr" target="_blank" rel="nofollow noopener">
                                    <div class="m-social__icon">
                                        <svg class="svg-icon svg-x" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#x"></use></svg>
                                    </div>
                                    <span class="sr-only">X (anciennement twitter)</span>
                                </a>
                            </li>
                            <li class="m-social__item">
                                <a class="m-social__link" href="https://www.youtube.com/channel/UCd1zuSaU5cE1lRCpwv_HSMA" target="_blank" rel="nofollow noopener">
                                    <div class="m-social__icon">
                                        <svg class="svg-icon svg-youtube" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#youtube"></use></svg>
                                    </div>
                                    <span class="sr-only">youtube</span>
                                </a>
                            </li>
                            <li class="m-social__item">
                                <a class="m-social__link" href="https://esante.gouv.fr/rss.xml" target="_blank" rel="nofollow noopener">
                                    <div class="m-social__icon">
                                        <svg class="svg-icon svg-rss" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#rss"></use></svg>
                                    </div>
                                    <span class="sr-only">rss</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-6 col-lg-3">
                    <ul class="footer-list">
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href=" https://esante.gouv.fr/lagence/nous-rejoindre">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.carrieres' | translate }}</a
                            >
                        </li>
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href="https://esante.gouv.fr/espace-presse">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.espacePresse' | translate }}</a
                            >
                        </li>
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href="https://esante.gouv.fr/lagence/marches-publics">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.marchePublics' | translate }}</a
                            >
                        </li>
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href="https://esante.gouv.fr/formulaire-infolettre">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.newsletter' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>
                <div class="col-6 col-lg-3">
                    <ul class="footer-list">
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href="https://esante.gouv.fr/webinaires">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.webinaires' | translate }}</a
                            >
                        </li>
                        <li class="footer-list__item footer-list__item--hasIcon">
                            <a rel="noopener" href="https://esante.gouv.fr/contact">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>{{ 'footer.contactezNous' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="footer__region2">
        <div class="container">
            <div class="footer-contentinfo">
                <ul class="footer-list footer-list--inline">
                    <li class="footer-list__item">
                        <a rel="noopener" class="external-link" href="https://sante.gouv.fr/" target="_blank">{{ 'global.ministere' | translate }}</a>
                    </li>
                    <li class="footer-list__item">
                        <a rel="noopener" class="external-link" href="https://www.legifrance.gouv.fr/" target="_blank">{{ 'footer.legifrance' | translate }}</a>
                    </li>
                    <li class="footer-list__item">
                        <a rel="noopener" class="external-link" href="https://www.service-public.fr/" target="_blank">{{ 'footer.service' | translate }}</a>
                    </li>
                    <li class="footer-list__item">
                        <a rel="noopener" [href]="urlPdfJson.MENTIONS_LEGALES_URL">{{ 'footer.mentions' | translate }}</a>
                    </li>
                    <li class="footer-list__item">
                        <a rel="noopener" [href]="urlPdfJson.CONDITIONS_GENERALES_URL">{{ 'footer.cgu' | translate }}</a>
                    </li>
                    <li class="footer-list__item">
                        <a [routerLink]="['/declaration-accessibilite']">{{ 'footer.accessibilityStatement' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>
